import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchQuery, onSearchChange, resultsCount }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative"
    >
      <div className="relative">
        <Input
          type="search"
          placeholder="Search articles by title, topic, or keyword..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="pl-12 pr-4 bg-slate-800/50 border-teal-500/30 text-white placeholder:text-slate-500 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/50 rounded-xl h-12"
        />
        <Icon
          name="Search"
          size={20}
          color="#14b8a6"
          className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none"
        />
      </div>
      {searchQuery && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-3 text-sm text-teal-400 font-medium"
        >
          Found {resultsCount} article{resultsCount !== 1 ? 's' : ''} matching "{searchQuery}"
        </motion.div>
      )}
    </motion.div>
  );
};

export default SearchBar;